import ErrorPage from './pages/ErrorPage';
import ProtectRoutes from './pages/ProtectRoutes';
import Search from './pages/SearchPage';
import './App.css';
import { Routes, Route } from "react-router-dom"
import Homepage from "./pages/Homepage"
import Privacy from './pages/Privacy';
import Company from './pages/Company'
import Settings from './pages/Settings';
import Help from './pages/Help';
import FeedBack from './pages/FeedBack';
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import MainPage from './pages/MainPage';
import Language from './features/user/Language';
import Bookmarks from './pages/Bookmarks';
import UserCarts from './pages/UserCarts';
import UserOrders from './pages/UserOrders';
import UserInvoices from './pages/UserInvoices';
import UserEvents from './pages/UserEvents';
import {
    //user
    Signup,
    Login,
    Profile,
    EditProfile,
    ResetPassword,
    ForgotPassword,
    EmailVerify,
    UserPosts,
    UserPost,
    UserOrgs,
    UserFriends,
    MyFriends,
    UserFollowers,
    UserFollowings,
    FriendRequestsReceived,
    FriendRequestsSent,
    FriendRequests,
    SuggestedFriends,
    UserPage,
    About,
    Posts,
    MyFollowers,
    MyFollowings,

    //posts
    CreatePost,

    // messages
    Chats,
    NewChat,


    //organisation
    Organization,
    CreateOrg,
    CreateOrgpost,
    MyOrgsList,
    Created,
    Followers,
    OrgFeeds,
    OrgPost,
    EditOrgPost,
    Members,
    Blacklisteds,
    Friends,
    MembershipRequests,
    FriendshipRequests,
    Admins,
    Branches,
    BranchesAccepted,
    BranchesJoinRequested,
    BranchesJoinRequesting,
    BranchesSuggested,
    ManageOrgAdmins,
    Member,
    Friend,
    Following,
    Admin,
    SuggestionBox,
    Suggestions,
    SuggestedOrgs,
    Manage,
    Parent,
    OrgSettings,
    Moderation,
    OrgAdminBranches,
    AddOrgAdmins,

    // org ads
    AdSelector,
    EditAd,
    PostsAds,
    PostAd,
    CreatePostAd,
    PreviousAds,
    OrgAdPayment,

    //marketplace
    StoreMenu,
    StoreAdminMenu,
    StoreAdmins,
    SingleStore,
    Stores,
    MyStores,
    FavouriteStores,
    CreateStore,
    EditStore,
    Products,
    Product,
    StoreBranches,
    CategoryStores,
    StoreSuggestions,
    StoreSuggest,
    StoreDashboard,
    AdminProducts,
    Invoices,
    Invoice,
    Shelf,
    StoreAddress,
    StoreContacts,
    StoreOrders,
    StoreOrder,
    StoreUserCarts,
    Carts,
    Cart,
    AddProduct,
    StoreFollowers,
    StoreSearches,

    //store management
    ManageBranches,
    StoreShelves,
    StoreShelf,
    EditProduct,
    EditShelf,
    AdminStoreInvoice,
    AdminStoreInvoices,
    AdminStoreOrders,
    AdminStoreOrder,
    PlanSelect,
    Checkout,
    RequestedStoreBranches,
    SuggestedStoreBranches,
    AddedBranches,
    ManageAdmins,
    AddAdmins,
    AddedParent,
    SellerPolicy,

    //store promotions
    StoreAdSelector,
    ShelvesAds,
    CreateProductAd,
    CreateShelfAd,
    CreateStoreAd,
    ProductsAds,
    StorePreviousAds,
    StoreAdsPayments,

    //notifications
    Notifications,
    OrganizationsList,
} from "./features/index"
import UserChat from './features/messages/UserChat';
import QrCodeCreate from './pages/QrCodeCreate';


const App = () => {

    return (
        <div className="App">
            <div className='main-container'>
                <ToastContainer />
                <Routes>
                    <Route path='/login' element={<Login />} />
                    <Route path='/signup' element={<Signup />} />
                    <Route path='/policy' element={<Privacy />} />
                    <Route path='/help' element={<Help />} />
                    <Route path='/forgot-password' element={<ForgotPassword />} />
                    <Route path='/reset-password' element={<ResetPassword />} />
                    <Route path='/email-verify' element={<EmailVerify />} />
                    <Route element={<ProtectRoutes />} >
                        <Route path="/" element={<MainPage />}>
                            <Route index element={<Homepage />} />
                            <Route path='/create' element={<CreatePost />} />
                            <Route path='/search' element={<Search />} />
                            <Route path='/language' element={<Language />} />
                            <Route path='/post/:id/*' element={<UserPost />} />
                            <Route path='/company' element={<Company />} />
                            <Route path='/settings' element={<Settings />} />
                            <Route path='/feedback' element={<FeedBack />} />
                            <Route path='/bookmarks' element={<Bookmarks />} />
                            <Route path='/events' element={<UserEvents />} />
                            <Route path='/carts' element={<UserCarts />} />
                            <Route path='/invoices' element={<UserInvoices />} />
                            <Route path='/orders' element={<UserOrders />} />


                            {/* /profiles routes */}
                            <Route path='/profile' element={<Profile />}>
                                <Route index element={<UserPosts />} />
                                <Route path='' element={<UserPosts />} />
                                <Route path='edit' element={<EditProfile />} />
                                <Route path='organizations' element={<UserOrgs />} />
                                <Route path='friends' element={<MyFriends />} />
                                <Route path='friend-requests' element={<FriendRequests />}>
                                    <Route index element={<FriendRequestsReceived />} />
                                    <Route path='sent' element={<FriendRequestsSent />} />
                                    <Route path='suggested' element={<SuggestedFriends />} />
                                </Route>
                                <Route path='followers' element={<MyFollowers />} />
                                <Route path='followings' element={<MyFollowings />} />
                            </Route>
                            <Route path='/user/:user' element={<UserPage />}>
                                <Route index element={<Posts />} />
                                <Route path='about' element={<About />} />
                                <Route path='friends' element={<UserFriends />} />
                                <Route path='followers' element={<UserFollowers />} />
                                <Route path='followings' element={<UserFollowings />} />
                                <Route path='organizations' element={<UserOrgs />} />
                            </Route>

                            {/* messages routes */}
                            <Route path='/chats' >
                                <Route index element={<Chats />} />
                                <Route path='friends' element={<NewChat />} />
                                <Route path='friends/:friend' element={<UserChat />} />
                            </Route>

                            {/* notifications routes */}
                            <Route path='/notifications'>
                                <Route index element={<Notifications />} />
                            </Route>
                            {/* organizations routes */}
                            <Route path='/organizations' element={<OrganizationsList />}>
                                <Route index element={<MyOrgsList />} />
                                <Route path='created' element={<Created />} />
                                <Route path='member' element={<Member />} />
                                <Route path='friend' element={<Friend />} />
                                <Route path='admin' element={<Admin />} />
                                <Route path='following' element={<Following />} />
                                <Route path='suggested' element={<SuggestedOrgs />} />
                                {/* organization route */}
                            </Route>
                            <Route path='/organizations/new' element={<CreateOrg />} />
                            <Route path='/:organization' element={<Organization />}>
                                <Route index element={<OrgFeeds />} />
                                <Route path='posts' element={<CreateOrgpost />} />
                                <Route path='posts/:id' >
                                    <Route index element={<OrgPost />} />
                                    <Route path='edit' element={<EditOrgPost />} />
                                </Route>
                                <Route path='suggestionbox' element={<SuggestionBox />} />
                                <Route path='suggestions' element={<Suggestions />} />
                                <Route path='branches' element={<BranchesAccepted />} />
                                <Route path='members' element={<Members />} />
                                <Route path='friends' element={<Friends />} />
                                <Route path='followers' element={<Followers />} />
                                <Route path='admins' element={<Admins />} />
                                <Route path='qrcode' element={<QrCodeCreate />} />
                            </Route>
                            <Route path='/:organization/admin' element={<Manage />}>
                                <Route index element={<MembershipRequests />} />
                                <Route path='suggestions' element={<Suggestions />} />
                                <Route path='moderation' element={<Moderation />} />
                                <Route path='branches' element={<Branches />}>
                                    <Route index element={<OrgAdminBranches />} />
                                    <Route path='suggested' element={<BranchesSuggested />} />
                                    <Route path='requested' element={<BranchesJoinRequested />} />
                                    <Route path='requesting' element={<BranchesJoinRequesting />} />
                                    <Route path='parent' element={<Parent />} />
                                </Route>
                                <Route path='Blacklisteds' element={<Blacklisteds />} />
                                <Route path='members/requests' element={<MembershipRequests />} />
                                <Route path='friends/requests' element={<FriendshipRequests />} />
                                <Route path='admins' >
                                    <Route index element={<ManageOrgAdmins />} />
                                    <Route path='new' element={<AddOrgAdmins />} />
                                </Route>
                                <Route path='promotions'>
                                    <Route index element={<AdSelector />} />
                                    <Route path='posts/create' element={<CreatePostAd />} />
                                    <Route path='posts' element={<PostsAds />}>
                                        <Route path='new' element={<PostAd />} />
                                    </Route>
                                    <Route path='previous' element={<PreviousAds />}>
                                        <Route path='edit' element={<EditAd />} />
                                    </Route>
                                    <Route path=':id/payments' element={<OrgAdPayment />} />
                                </Route>
                                <Route path='settings' element={<OrgSettings />} />
                            </Route>

                            {/* marketplace */}

                            {/*  stores routes */}
                            <Route path='/b' >
                                <Route index element={<Stores />} />
                                <Route path='search' element={<StoreSearches />} />
                                <Route path='carts' element={<Carts />} />
                                <Route path='mystores' element={<MyStores />} />
                                <Route path='favourites' element={<FavouriteStores />} />
                                <Route path='policy' element={<SellerPolicy />} />
                                <Route path='category/:category'>
                                    <Route index element={<CategoryStores />} />
                                </Route>
                                <Route path=':name' element={<StoreMenu />}>
                                    <Route index element={<SingleStore />} />
                                    <Route path="qrcode" element={<QrCodeCreate />} />
                                    <Route path="branches" element={<StoreBranches />} />
                                    <Route path="address" element={<StoreAddress />} />
                                    <Route path="contacts" element={<StoreContacts />} />
                                    <Route path="products">
                                        <Route index element={<Products />} />
                                        <Route path=":product" element={<Product />} />
                                    </Route>
                                    <Route path="orders">
                                        <Route index element={<StoreOrders />} />
                                        <Route path=":order" element={<StoreOrder />} />
                                    </Route>
                                    <Route path="invoices" >
                                        <Route index element={<Invoices />} />
                                        <Route path=":id" element={<Invoice />} />
                                    </Route>
                                    <Route path="carts" >
                                        <Route index element={<StoreUserCarts />} />
                                        <Route path=":cart" element={<Cart />} />
                                    </Route>
                                    <Route path="admins" element={<StoreAdmins />} />
                                    <Route path="suggestionbox" element={<StoreSuggest />} />
                                    <Route path=':shelf' >
                                        <Route index element={<Shelf />} />
                                        <Route path=':product' element={<Product />} />
                                    </Route>
                                </Route>

                                {/* stores administrations */}
                                <Route path='manage' >
                                    <Route index element={<MyStores />} />
                                    <Route path=':name' element={<StoreAdminMenu />}>
                                        <Route index element={<StoreDashboard />} />
                                        <Route path="branches" element={<ManageBranches />}>
                                            <Route index element={<AddedBranches />} />
                                            <Route path='sent-requests' element={<RequestedStoreBranches />} />
                                            <Route path='suggesteds' element={<SuggestedStoreBranches />} />
                                            <Route index element={<AddedParent />} />
                                        </Route>
                                        <Route path="products" element={<AdminProducts />} />
                                        <Route path="products/:id/edit" element={<EditProduct />} />
                                        <Route path='products/new' element={<AddProduct />} />
                                        <Route path="shelves" >
                                            <Route index element={<StoreShelves />} />
                                            <Route path=':shelf' element={<StoreShelf />} />
                                            <Route path=':shelf/edit' element={<EditShelf />} />
                                        </Route>
                                        <Route path="orders" >
                                            <Route index element={<AdminStoreOrders />} />
                                            <Route path=":id" element={<AdminStoreOrder />} />
                                        </Route>
                                        <Route path="invoices" >
                                            <Route index element={<AdminStoreInvoices />} />
                                            <Route path=":id" element={<AdminStoreInvoice />} />
                                        </Route>
                                        {/* <Route path="admins" element={<ManageAdmins />} /> */}
                                        <Route path="admins">
                                            <Route index element={<ManageAdmins />} />
                                            <Route path="new" element={<AddAdmins />} />
                                        </Route>
                                        <Route path="followers" element={<StoreFollowers />} />
                                        <Route path="suggestions" element={<StoreSuggestions />} />
                                        <Route path="promotions"  >
                                            <Route index element={<StoreAdSelector />} />
                                            <Route path='products' element={<ProductsAds />} />
                                            <Route path='shelves' element={<ShelvesAds />} />
                                            <Route path='previous' element={<StorePreviousAds />} />
                                            <Route path='create' element={<CreateProductAd />} />
                                            <Route path='store/create' element={<CreateStoreAd />} />
                                            <Route path='shelf/create' element={<CreateShelfAd />} />
                                            <Route path=':id/payments' element={<StoreAdsPayments />} />
                                        </Route>
                                        <Route path="edit" element={<EditStore />} />
                                        <Route path="plan" >
                                            <Route index element={<PlanSelect />} />
                                            <Route path='checkout' element={<Checkout />} />
                                        </Route>
                                    </Route>
                                </Route>
                            </Route>
                            <Route path='/b/create' element={<CreateStore />} />
                        </Route>
                        <Route path='/*' element={<ErrorPage />}></Route>
                    </Route>
                </Routes>
            </div>
        </div >
    )

}

export default App


